<template>
  <v-dialog v-model="dialog" @input="close" max-width="600">
    <DefineTemplate>
      <v-card-actions>
        <v-btn text @click="step > 1 ? step-- : null">
          Vissza
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="step < 5 ? step++ : null">
          Tovább
        </v-btn>
      </v-card-actions>
    </DefineTemplate>

    <form @submit.prevent="save">
      <v-card>
        <v-card-title>
          <v-icon left>{{ dialogHeader.icon }}</v-icon> {{ dialogHeader.title }}
          <v-spacer />
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-stepper v-model="step" vertical>
          <v-stepper-step :complete="step > 0" step="1">
            Alapadatok
            <small>Adja meg az alapadatokat</small>
          </v-stepper-step>

          <v-stepper-content step="1">

            <v-text-field
              label="Kontroller"
              :error-messages="errors.name"
              v-model="controller.name"
              filled
              readonly
              hint="nem szerkeszthető" />

            <v-text-field
              label="Név"
              :error-messages="errors.name"
              v-model="gate.name"
              filled
              clearable />

            <v-textarea
              v-model="gate.comment"
              label="Megjegyzés"
              filled
              rows="3"
              auto-grow />

            <ReuseTemplate />
          </v-stepper-content>

          <v-stepper-step :complete="step > 1" step="2" :rules="[() => step <= 2]">
            Olvasó hozzáadása
            <small v-if="step > 2" class="red--text">Olvasó megadása kötelező</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>

            <ReuseTemplate />
          </v-stepper-content>

          <v-stepper-step :complete="step > 2" step="3" :rules="[() => step <= 3]">
            Relé hozzáadása
            <!-- <small>Summarize if needed</small> -->
            <small v-if="step > 3" class="red--text">Relé megadása kötelező</small>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>

            <ReuseTemplate />
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="4">
            Lokáció
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-row>
              <v-col :cols="12" :sm="6">
                <v-autocomplete
                  label="Épület"
                  :error-messages="errors.building_id"
                  v-model="gate.building_id"
                  :items="buildings"
                  item-text="name"
                  item-value="id"
                  filled
                  @change="gate.building_level_id = null"
                  :value-comparator="$config.comparators.isEqual"
                  required />
              </v-col>
              <v-col :cols="12" :sm="6">
                <v-autocomplete
                  label="Épület szint"
                  :error-messages="errors.building_level_id"
                  v-model="gate.building_level_id"
                  :items="buildingLevels"
                  item-text="name"
                  item-value="id"
                  filled
                  persistent-hint
                  :disabled="!gate.building_id"
                  :hint="gate.building_id ? '' : 'Épület kötelező'"
                  :value-comparator="$config.comparators.isEqual"
                  required />
              </v-col>
              <v-col :cols="6" :sm="6">
                <v-text-field
                  label="X koordináta"
                  :error-messages="errors.x_coord"
                  v-model="gate.x_coord"
                  type="number"
                  filled />
              </v-col>
              <v-col :cols="6" :sm="6">
                <v-text-field
                  label="Y koordináta"
                  :error-messages="errors.y_coord"
                  v-model="gate.y_coord"
                  type="number"
                  filled />
              </v-col>
            </v-row>

            <ReuseTemplate />
          </v-stepper-content>

          <v-stepper-step :complete="step > 4" step="5">
            Összegzés
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>

            <v-card-actions>
              <v-btn class="ma-2" text @click="step > 1 ? step-- : null">
                Vissza
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper>

        <!-- <v-row>
          <v-col cols="12" lg="6">
            <v-card-text>
              <v-text-field label="Kontroller" :error-messages="errors.name" v-model="controller.name" filled
                readonly />

              <v-text-field label="Név" :error-messages="errors.name" v-model="gate.name" filled clearable />

              <v-textarea v-model="gate.comment" label="Megjegyzés" filled rows="3" auto-grow />
            </v-card-text>
          </v-col>

          <v-col cols="12" lg="6">

            <v-card-title>Olvasók</v-card-title>
            <v-card-text>
              <v-btn color="primary">
                <v-icon left>mdi-plus</v-icon>
                Új olvasó
              </v-btn>
            </v-card-text>

            <v-card-title>Relék</v-card-title>
            <v-card-text>
              <v-btn color="primary">
                <v-icon left>mdi-plus</v-icon>
                Új relé
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>

                <v-row>
          <v-col :cols="12" :md="3" :sm="6">
            <v-autocomplete
              label="Épület"
              :error-messages="errors.building_id"
              v-model="gate.building_id"
              :items="buildings"
              item-text="name"
              item-value="id"
              filled
              @change="gate.building_level_id = null"
              :value-comparator="$config.comparators.isEqual"
            />
          </v-col>
          <v-col :cols="12" :md="3" :sm="6">
            <v-autocomplete
              label="Épület szint"
              :error-messages="errors.building_level_id"
              v-model="gate.building_level_id"
              :items="buildingLevels"
              item-text="name"
              item-value="id"
              filled
              persistent-hint
              :disabled="!gate.building_id"
              :hint="gate.building_id ? '' : 'Épület kötelező'"
              :value-comparator="$config.comparators.isEqual"
            />
          </v-col>
          <v-col :cols="6" :md="3" :sm="6">
            <v-text-field
              label="X koordináta"
              :error-messages="errors.x_coord"
              v-model="gate.x_coord"
              type="number"
              filled
            />
          </v-col>
          <v-col :cols="6" :md="3" :sm="6">
            <v-text-field
              label="Y koordináta"
              :error-messages="errors.y_coord"
              v-model="gate.y_coord"
              type="number"
              filled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="12" :md="6" :sm="12">
            <v-switch
              label="Kiegészítő eszköz"
              :error-messages="errors.additional"
              v-model="gate.additional.selected"
            />
            <v-text-field
              label="Megnevezés kiegészítés"
              :error-messages="errors.name_addition"
              v-model="gate.name_addition"
              filled
            />
          </v-col>
          <v-col :cols="12" :md="6">
            <v-switch
              :error-messages="errors.opening_warning"
              v-model="gate.open_warning.selected"
            >
              <template v-slot:label>
                <div>
                  <div>Tartós nyitás figyelmeztetés</div>
                  <div class="text-caption">
                    Olyan záraknál kell beállítani, ahol a hosszú nyitójel tönkreteheti azt
                  </div>
                </div>
              </template>
</v-switch>
</v-col>
</v-row> -->

        <v-divider />

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            type="submit"
            class="ma-2"
            :loading="loading"
            :disabled="step < 5">Mentés</v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
import { createReusableTemplate } from '@vueuse/core';
import { defineComponent } from 'vue';

const [DefineTemplate, ReuseTemplate] = createReusableTemplate();


export default {
  components: {
    DefineTemplate,
    ReuseTemplate,
  },
  props: {
    value: Boolean,
    gateType: 'barrier' | 'door' | 'turnstile',
    controller: Object,
  },

  data: () => ({
    step: 1,
    dialog: false,
    loading: false,
    errors: {},
    gate: {
      name: '',
      comment: '',
    },
  }),

  watch: {
    value: {
      immediate: true,

      handler(value) {
        this.dialog = value;

        if (value) {
          this.fetchGateways();
        }
      },
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$emit('input', false);
      this.$emit('close');
    },


    async fetchGateways() {
      const response = await this.$http.get(`gateways/list`);
      this.gateways = response.gateways;
    },

    async save() {
      try {
        this.loading = true;
        this.errors = {};

        // const response = await this.$http.post('connections/save', this.connection);
        // if (response.status === 'OK' && Object.entries(response.errors).length === 0) {
        //   this.$emit('save', response.connection);
        //   this.close();
        //   this.connection = {};
        //   this.$dialog.notify.success('Sikeres mentés!');
        // } else {
        //   this.errors = response.errors;
        // }
      }
      catch (e) {
        console.error(e);
      }
      finally {
        this.loading = false;
      }
    },
  },

  computed: {
    dialogHeader() {
      switch (this.gateType) {
        case 'barrier':
          return {
            title: 'Sorompó létrehozása',
            icon: 'mdi-boom-gate-up',
          };
        case 'door':
          return {
            title: 'Ajtó létrehozása',
            icon: 'mdi-door',
          };
        case 'turnstile':
          return {
            title: 'Forgóvilla létrehozása',
            icon: 'mdi-turnstile',
          };
        default:
          return 'Kapu létrehozása';
      }
    },
  },

  asyncComputed: {
    buildings: {
      async get() {
        const response = await this.$http.get(`buildings/list`);
        return response.buildings;
      }
    },
    buildingLevels: {
      async get() {
        const response = await this.$http.get(`building-levels/list`);
        return response.building_levels;
      }
    },
  },
};
</script>